import React from 'react';
import { Radio } from 'react-form';

import Img from '../../Img';

import styles from './simpleRadio.scss';

const SimpleRadio = (props) => {
    const { field, option, value, disabled, 'data-testid': dataTestId } = props;
    return (
        <div className={`${styles.simpleRadio} d-flex aic mb8`} data-testid={dataTestId || undefined}>
            <Radio
                id={`${field}-${option.value}`}
                value={option.value}
                disabled={disabled}
                checked={value === option.value}
            />
            <label htmlFor={`${field}-${option.value}`} className="mb0">
                <div className={styles.check} data-testid={dataTestId && `${dataTestId}.check-icon`}><Img src="/img/icons/checkmark-icon.svg" /></div>
                <div className={styles.label} data-testid={dataTestId && `${dataTestId}.label`}>{option.label}</div>
            </label>
        </div>
    );
};

export default SimpleRadio;
